<template>
  <div class="appBody bg-white">
    <!--    <div class="shareImg position-fixed cursor-pointer">-->
    <!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
    <!--    </div>-->
    <little-header></little-header>
    <div v-if="!loading ">
      <div v-if="sessionVideo && sessionVideo.id">
        <div class="shipin-div" id="studyFinish"
             :data-currentDuration=currentDuration
             :data-completeDuration=completeDuration
             :data-drag=sessionVideo.drag
             :data-speed=sessionVideo.speed
             :data-lastDuration=lastDurationFromService
        >
          <iframe name="myFrame" class="w-100 h-100" :src="'/static/videott/index.html?vid='+ vid"/>
        </div>
        <van-row class="video-title d-flex">
          <van-col class="icn">
            <div class="lantiao"></div>
          </van-col>
          <van-col class="color-88 font-13 line-15">
            {{sessionVideo.title}}
          </van-col>
        </van-row>
        <!--        <van-row class="video-stat d-flex align-items-center" v-if="sessionVideo.recordStudy">-->
        <!--          <van-col class="d-flex align-items-center">-->
        <!--            <img class="ml-10 fs-img" src="/static/img/pro/video_finish_stat.png" alt="">-->
        <!--            <div class="ml-10 color-33 font-12 line-12" v-if="sessionVideo && sessionVideo.statInfo">-->
        <!--              <span>{{sessionVideo.statInfo.joinedCount?sessionVideo.statInfo.joinedCount:0}}人学习</span>-->
        <!--              <span class="position-relative" style="top: -1px">|</span>-->
        <!--              <span>{{sessionVideo.statInfo.learnedCount?sessionVideo.statInfo.learnedCount:0}}人完成</span>-->
        <!--            </div>-->
        <!--          </van-col>-->

        <!--          <van-col class="d-flex align-items-center ml-auto">-->
        <!--            <div v-if="currentDuration<completeDuration">-->
        <!--              <img v-if="videoPlaying" class="mr-10 fs-img" src="/static/img/pro/play_playing.gif" alt="">-->
        <!--              <img v-else class="mr-10 fs-img" src="/static/img/pro/play_stop.jpg" alt="">-->
        <!--            </div>-->
        <!--            <div class="color-33 font-12 line-12">-->
        <!--              {{(currentDuration>=completeDuration)?'已完成':'学习记录中'}}-->
        <!--            </div>-->
        <!--          </van-col>-->
        <!--        </van-row>-->
<!--        <van-row class="video-stat d-flex align-items-center " v-if="currentDuration<completeDuration && sessionVideo.recordStudy">
          <div class="ml-10 color-88 font-12 line-12">
            学习进度
          </div>
          <van-progress class="progress2 mx-2"
                        :percentage="(Math.floor(currentDuration)/completeDuration)*100|calcMoney"
                        stroke-width="4"/>
          <van-col class="color-88 font-12 line-13 ml-4 pl-2">
            {{(currentDuration>=completeDuration?completeDuration:currentDuration)|getVideoTimeStr}}/{{completeDuration|getVideoTimeStr}}
          </van-col>

          <van-col class="ml-auto font-13 line-13 font-weight-bold text-primary">
            {{(currentDuration>=completeDuration) ? '已完成' : '学习中...'}}
          </van-col>
        </van-row>-->
        <!--      <van-row class="video-stat user-div mt-20 d-flex align-items-center border-bottom-0">-->
        <!--        <div>-->
        <!--          <img class="ml-10 u-avatar" :src="userInfo.avatarUrl|getAvator" alt="">-->
        <!--        </div>-->
        <!--        <van-col class="color-33 font-13 line-13 ml-2">-->
        <!--          {{userInfo.nickname?userInfo.nickname:''}}-->
        <!--        </van-col>-->
        <!--        <van-col class="guanzhu-btn border-primary border text-primary background ml-auto font-13 line-13 ">-->
        <!--          关注-->
        <!--        </van-col>-->
        <!--      </van-row>-->
        <van-row class="video-stat d-flex align-items-center my-2">
          <like-component :type="mainType" :main-id="tid" status="true"></like-component>
          <rate-component :type="mainType" :main-id="tid"></rate-component>
        </van-row>

        <comment-component :type="mainType" :main-id="tid"></comment-component>

      </div>

      <no-data v-else text="暂无视频内容"></no-data>
    </div>
    <van-loading class="my-5" v-else size="24px" vertical>加载中...</van-loading>

    <little-footer></little-footer>
  </div>
</template>
<script>
  import CommentComponent from './component/commentComponent'
  import RateComponent from './component/rateComponent';
  import LikeComponent from './component/likeComponent';
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";
  import NoData from "@/components/noData";
  import {mapState} from "vuex";
  import Vue from 'vue';
  import {
    Icon,
    SwipeCell,
    Button,
    Col,
    Row,
    Card,
    Progress,
    Loading,
    Field,
    Overlay,
    Tab,
    Tabs,
    Rate,
    Image as VanImage
  } from 'vant';

  Vue.use(VanImage);
  Vue.use(Field);
  Vue.use(Overlay);
  Vue.use(Rate);
  Vue.use(Tab);
  Vue.use(Tabs);
  Vue.use(Card);
  Vue.use(Progress);
  Vue.use(Col);
  Vue.use(Row);
  Vue.use(Button);
  Vue.use(SwipeCell);
  Vue.use(Icon);
  Vue.use(Loading);

  export default {
    name: "videoSession",
    data() {
      return {
        loading: false,
        tid: '',
        sessionVideo: {},
        userInfo: {},
        userSessionVideo: {},
        currentDuration: 0,
        completeDuration: 0,
        allDuration: 0,
        studyFinish: true,
        videoPlaying: false,
        vid: '',
        lastDuration: 0, // 上次学习时长（最后播放位置）
        lastDuration1: 0,
        lastDurationFromService: 0,
        lastReportDuration: 0,
        timer: {},
        cTime: {},
        mainType: 'session-video',
        likeObj: {},
      }
    },
    components: {
      LittleHeader,
      littleFooter,
      NoData,
      CommentComponent,
      RateComponent,
      LikeComponent,
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        recordStudyTip: state => state.recordStudy
      })
    },
    mounted() {
      this.tid = this.$route.params['id'];
      this.getVideoObj();
    },
    destroyed() {
      clearInterval(this.timer);
      this.timer = null;
      clearInterval(this.cTime);
      this.cTime = null;
    },
    methods: {
      getVideoObj() {
        this.loading = true;
        this.$store.dispatch('getVideoSessionById', {id: this.tid}).then((res) => {
          if (res) {
            this.loading = false;
            this.sessionVideo = res;
            if (res.creatorUser) {
              this.userInfo = res.creatorUser;
            }
            if (res.videoResource && res.videoResource.url) {
              this.vid = res.videoResource.url;
            }
            // 如果超出学习时间，可以观看但不再记录学习
            if(!res.recordStudy) {
              setTimeout(()=>{
                this.$toast({
                  message: this.recordStudyTip,
                  duration: 3000
                });
              }, 1000);
              return;
            }
            if (res.userSessionVideo) {
              this.userSessionVideo = res.userSessionVideo;
              /// 读取服务端的学习进度
              if (this.userSessionVideo) {
                this.currentDuration = this.userSessionVideo.duration;
                this.completeDuration = this.sessionVideo.completeDuration;
                this.studyFinish = this.userSessionVideo.finished;
                this.lastDurationFromService = this.userSessionVideo.lastDuration;
                this.allDuration = this.sessionVideo.duration;
              }
            }

            /**
             * 未完成
             * 剩余时长大于1分钟的，每一分钟记录一次，监听结束时间，记录完成
             * 剩余时长小于1分钟的，监听结束时间，记录完成
             * @type {number}
             */
            this.cTime = setInterval(() => {
              if (myFrame.window.startVideo()) {
                this.lastDuration = myFrame.window.currentTime();
                //如果剩余完成时间不足或等于60秒，就会监听完成的时间，到时间后就改变状态
                if (this.completeDuration - this.currentDuration <= 60) {
                  if (this.lastDuration >= this.completeDuration && !this.studyFinish) {
                    //已完成时长要求
                    this.studyFinish = true;
                    this.reportProgressCallBack();
                    clearInterval(this.cTime);
                  }
                } else {
                  //如果剩余完成时间超过60秒，计算lastDuration-currentDuration ，如果>60秒，记录
                  if (this.lastDuration - this.currentDuration >= 60) {
                    this.lastDuration = this.currentDuration + 60;
                    this.reportProgressCallBack();
                  }
                }
              }
            }, 1000)
          }
        });
      },

      reportProgressCallBack() {
        this.lastReportDuration = this.lastDuration < this.currentDuration ? this.currentDuration : this.lastDuration;
        this.$store.dispatch('learnVideoSession', {
          id: this.sessionVideo.id,
          model: {duration: this.lastReportDuration, lastDuration: this.lastDuration}
        }).then((res) => {
          if (!res) {
            // this.$toast('记录学习进度成功！');
            this.currentDuration = this.lastReportDuration;
          } else {
            this.$toast('记录学习进度失败，请检查网络连接！');
          }
        },(error) => {
          /// 错误提示
          if (error.response.data.errorType === 'UserProjectNotInStartTimeException') {
            this.$toast({
              message: this.recordStudyTip,
              duration: 5000
            });
            clearInterval(this.cTime);
          }
        })
      },

      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //   this.shareObj = this.sessionVideo;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'session';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
      //   this.$router.push('/share-poster');
      // },
    }
  }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }

  .rate-show {
    border: 1px solid #2474ff;
    padding: pxTorem(2px) pxTorem(10px) pxTorem(2px) pxTorem(10px);
    border-radius: pxTorem(4px);
  }

  .rate {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .rate-block {
    width: pxTorem(300px);
    background-color: #fff;
    padding: pxTorem(32px) pxTorem(16px) pxTorem(16px) pxTorem(16px);
    .avatar {
      width: pxTorem(24px);
      height: pxTorem(24px);
    }
    .close-tn {
      right: pxTorem(8px);
      top: pxTorem(8px);
      color: #666666;
    }
  }

  .u-avatar {
    width: pxTorem(20px);
    height: pxTorem(20px);
    border-radius: 50%;
  }

  .h-12 {
    height: pxTorem(12px);
  }

  .user-div {
    min-height: pxTorem(120px);
  }

  .shipin-div {
    height: pxTorem(210px);
    background-color: #000000;
    width: 100%;
  }

  .video-title {
    padding: pxTorem(13px) pxTorem(10px) pxTorem(2px) pxTorem(10px);

    .lantiao {
      height: pxTorem(12px);
      width: pxTorem(3px);
      border-radius: pxTorem(3px);
      margin-right: pxTorem(8px);
    }

    .text-black-26 {
      color: #00000042;
    }
  }

  .video-stat {
    margin: 0 pxTorem(10px) 0 pxTorem(10px);
    min-height: pxTorem(40px);
    border-bottom: pxTorem(1px) solid #eeeeee;

    .fs-img {
      height: pxTorem(12px);
    }

    .progress2 {
      width: pxTorem(40px);
      height: pxTorem(10px) !important;
      border-radius: pxTorem(2px);
    }

    .guanzhu-btn {
      background: white;
      width: pxTorem(64px);
      height: pxTorem(25px);
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }


</style>
